import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
  CContainer,
  CHeaderNav,
  CNavItem,
  CNavLink,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CDropdownDivider,
  CRow,
  CCol,
} from '@coreui/react'
import AppHeader from './AppHeaderPortalSitio'
import AppBreadcrumbSitio from './AppBreadcrumbSitio'
import api from 'src/api/api'
import { useLocation, useParams } from 'react-router-dom/cjs/react-router-dom.min'

const AppHeaderSitio = (props) => {
  const { id, sitio } = props
  const params = useLocation()
  const [nombre, setNombre] = useState([])
  const [menu, setMenu] = useState([])
  const [size, setSize] = useState(window.innerWidth)
  const basePath = String(process.env.PUBLIC_URL).trim() + '/' + sitio

  const cambio = () => {
    setSize(window.innerWidth)
  }

  const setActiveMenus = (menus, idActual) => {
    let newMenus = []

    for (let menu of menus) {
      let newMenu = { ...menu }

      if (menu?.nodos && menu?.nodos.length > 0) {
        const childNodeMenus = setActiveMenus(menu.nodos, idActual)
        newMenu.nodos = childNodeMenus

        const activeChild = childNodeMenus.find(({ active }) => active)
        if (activeChild) newMenu.active = true
      }

      /**
       * Anteriormente era newMenu.to.includes(idActual)
       * pero podia marcar dos items si por ejemplo idActual = ejes
       * y habia un menu con to = /ejes y otro con to = /ejesdegestion
       * La regex reconoce cadenas que sean /idActual o /idActual/
       */
      let regex = new RegExp(`/${idActual}(/|"")`)
      if (regex.test(newMenu.to) || (idActual === 'noticias' && newMenu.to === '/noticias')) {
        newMenu.active = true
      }

      newMenus.push(newMenu)
    }
    return newMenus
  }

  useEffect(() => {
    const idActual = id ?? params.pathname.split('/').at(-1)

    if (window.innerWidth > 767) {
      api.sitiosEncabezado({ url: sitio }).then((response) => {
        if (response.data.success) {
          setNombre(response.data.data.sitio)
          setMenu(setActiveMenus(response.data.data.menu, idActual))
        }
      })
    } else {
      api.sitiosEncabezadoCompleto({ url: sitio }).then((response) => {
        if (response.data.success) {
          setNombre(response.data.data.sitio)
          setMenu(setActiveMenus(response.data.data.menu, idActual))
        }
      })
    }
    window.addEventListener('resize', cambio)
  }, [sitio])

  return (
    <>
      <AppHeader sitio={nombre} base={'/' + sitio} menu_sitio={menu} />
      <CContainer fluid className="container-er mt-4">
        {size > 767 && (
          <CRow>
            <CCol>
              <AppBreadcrumbSitio sitio={nombre} ruta={sitio} />
            </CCol>
          </CRow>
        )}
        <a className="titulo-sitios" href={basePath + '/inicio'}>
          {nombre}
        </a>
        {size > 767 && (
          <div className="alineado-end w-100 alto-menu-int mt-3">
            <CHeaderNav className="menu-int-derecha">
              {menu.map((_nav, index) =>
                index === 0 ? (
                  'nodos' in _nav && _nav.nodos?.length > 0 ? (
                    <CDropdown variant="nav-item" popper={true} key={'item_' + index}>
                      <CDropdownToggle className="dropdown-sitios encabezado-sitios">
                        <span style={{ color: _nav.active ? '#82A55A' : 'inherit' }}>
                          {_nav.name.toUpperCase()}
                        </span>
                      </CDropdownToggle>
                      <CDropdownMenu>
                        {_nav.nodos.map((nodo, _index) => {
                          return (
                            <>
                              {_index > 0 && <CDropdownDivider />}
                              <CDropdownItem
                                key={index + '-nodo-' + _index}
                                href={basePath + nodo.to}
                              >
                                {nodo.name}
                              </CDropdownItem>
                            </>
                          )
                        })}
                      </CDropdownMenu>
                    </CDropdown>
                  ) : (
                    <CNavItem key={'item_' + index}>
                      <CNavLink
                        href={_nav.target === '_blank' ? _nav.to : basePath + _nav.to}
                        target={_nav.target}
                        className="clase-subrayado-int encabezado-sitios"
                        key={'link_' + index}
                        active
                      >
                        <span style={{ color: _nav.active ? '#82A55A' : 'inherit' }}>
                          {_nav.name.toUpperCase()}
                        </span>
                      </CNavLink>
                    </CNavItem>
                  )
                ) : 'nodos' in _nav && _nav.nodos.length > 0 ? (
                  <>
                    <CNavItem key={'item_separador_' + index}>
                      <CNavLink
                        className="clase-subrayado-int"
                        key={'link_separador_' + index}
                        active
                      >
                        |
                      </CNavLink>
                    </CNavItem>
                    <CDropdown variant="nav-item" popper={true} key={'item_' + index}>
                      <CDropdownToggle className="dropdown-sitios encabezado-sitios">
                        <span style={{ color: _nav.active ? '#82A55A' : 'inherit' }}>
                          {_nav.name.toUpperCase()}
                        </span>
                      </CDropdownToggle>
                      <CDropdownMenu>
                        {_nav.nodos.map((nodo, _index) => {
                          return (
                            <>
                              {_index > 0 && <CDropdownDivider />}
                              <CDropdownItem
                                key={index + '-nodo-' + _index}
                                href={basePath + nodo.to}
                              >
                                {nodo.name}
                              </CDropdownItem>
                            </>
                          )
                        })}
                      </CDropdownMenu>
                    </CDropdown>
                  </>
                ) : (
                  <>
                    <CNavItem key={'item_separador_' + index}>
                      <CNavLink
                        className="clase-subrayado-int"
                        key={'link_separador_' + index}
                        active
                      >
                        |
                      </CNavLink>
                    </CNavItem>
                    <CNavItem key={'item_' + index}>
                      <CNavLink
                        href={_nav.target === '_blank' ? _nav.to : basePath + _nav.to}
                        target={_nav.target}
                        className="clase-subrayado-int encabezado-sitios"
                        key={'link_' + index}
                        active
                      >
                        <span style={{ color: _nav.active ? '#82A55A' : 'inherit' }}>
                          {_nav.name.toUpperCase()}
                        </span>
                      </CNavLink>
                    </CNavItem>
                  </>
                ),
              )}
            </CHeaderNav>
          </div>
        )}
        <div className="header-divider-sitios"></div>
      </CContainer>
    </>
  )
}

AppHeaderSitio.propTypes = {
  id: PropTypes.string.isRequired,
  sitio: PropTypes.string.isRequired,
}

export default React.memo(AppHeaderSitio)
